import { render, staticRenderFns } from "./Multifirma.vue?vue&type=template&id=362c7c0a"
import script from "./Multifirma.vue?vue&type=script&lang=js"
export * from "./Multifirma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports